var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEmployerCodePrescriptions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.58 99.159c27.381 0 49.579-22.198 49.579-49.58C99.159 22.197 76.96 0 49.579 0 22.197 0 0 22.197 0 49.58 0 76.96 22.197 99.158 49.58 99.158Z",
    fill: "#FDD59E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.424 100c15.376 0 27.84-7.197 27.84-16.074 0-8.877-12.464-16.074-27.84-16.074-15.375 0-27.84 7.197-27.84 16.074C3.584 92.803 16.05 100 31.424 100Z",
    fill: "#000",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.382 90.62H52.97a6.294 6.294 0 0 0 6.294-6.293v-7.68c-1.529-11.732-1.422-22.11 0-34.482v-6.903L20.323 29.11l-9.235 34.78V84.33a6.294 6.294 0 0 0 6.294 6.292Z",
    fill: "#FFBE71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.264 42.161H27.682a4.96 4.96 0 0 0-4.96 4.96v24.563a4.96 4.96 0 0 0 4.96 4.96h31.582V42.16Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.28 55.435h-5.915V49.52h-7.936v5.915h-5.915v7.935h5.915v5.916h7.936V63.37h5.915v-7.935Z",
    fill: "#F74F73"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.088 24.228h48.176v11.03H11.088v-11.03Z",
    fill: "#EF8E4D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.328 30.6h39.354v-8.485a4.906 4.906 0 0 0-4.906-4.903H29.65c-2.65 4.57-4.667 9.063-5.323 13.388Z",
    fill: "#FFBE71"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.576 17.211a4.906 4.906 0 0 0-4.903 4.907v8.484h17.655l5.325-13.389-18.077-.002Z",
    fill: "#EF8E4D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.86 24.228H11.088v39.658L26.86 24.228Z",
    fill: "#EF8E4D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m79.834 61.213 5.324 2.572a3.802 3.802 0 0 1-3.307 6.846l-5.325-2.572c.702-2.74 1.71-5.132 3.308-6.846Z",
    fill: "#BDDEFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m74.51 58.64 5.324 2.573-3.308 6.846-5.323-2.572a3.802 3.802 0 0 1 3.306-6.847h.001Z",
    fill: "#7AAEED"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m73.099 85.118-5.183 2.636a3.738 3.738 0 1 1-3.389-6.663l5.183-2.636c1.606 1.653 2.643 3.983 3.389 6.663Z",
    fill: "#BDDEFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M74.892 75.819a3.738 3.738 0 0 1 3.388 6.663L73.1 85.118l-3.39-6.663 5.182-2.636Z",
    fill: "#7AAEED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmployerCodePrescriptions);
export default __webpack_public_path__ + "static/media/icon_employer_code_prescriptions.17a59620.svg";
export { ForwardRef as ReactComponent };